module.exports = __webpack_public_path__ + "static/img/right-man.3c55c5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/default/right-man.png
// module id = 8k7r
// module chunks = 2